/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUserManagementRouteImport } from './routes/admin/user-management'
import { Route as AdminQuizzesRouteImport } from './routes/admin/quizzes'
import { Route as AdminNotificationsRouteImport } from './routes/admin/notifications'
import { Route as AdminCampusResourcesRouteImport } from './routes/admin/campus-resources'
import { Route as AdminArticlesRouteImport } from './routes/admin/articles'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminQuizzesIndexRouteImport } from './routes/admin/quizzes/index'
import { Route as AdminQuizzesQuizIdRouteImport } from './routes/admin/quizzes/$quizId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUserManagementRoute = AdminUserManagementRouteImport.update({
  id: '/user-management',
  path: '/user-management',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuizzesRoute = AdminQuizzesRouteImport.update({
  id: '/quizzes',
  path: '/quizzes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCampusResourcesRoute = AdminCampusResourcesRouteImport.update({
  id: '/campus-resources',
  path: '/campus-resources',
  getParentRoute: () => AdminRoute,
} as any)
const AdminArticlesRoute = AdminArticlesRouteImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuizzesIndexRoute = AdminQuizzesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminQuizzesRoute,
} as any)
const AdminQuizzesQuizIdRoute = AdminQuizzesQuizIdRouteImport.update({
  id: '/$quizId',
  path: '/$quizId',
  getParentRoute: () => AdminQuizzesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/admin/campus-resources': typeof AdminCampusResourcesRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/quizzes': typeof AdminQuizzesRouteWithChildren
  '/admin/user-management': typeof AdminUserManagementRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/quizzes/$quizId': typeof AdminQuizzesQuizIdRoute
  '/admin/quizzes/': typeof AdminQuizzesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/admin/campus-resources': typeof AdminCampusResourcesRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/user-management': typeof AdminUserManagementRoute
  '/admin': typeof AdminIndexRoute
  '/admin/quizzes/$quizId': typeof AdminQuizzesQuizIdRoute
  '/admin/quizzes': typeof AdminQuizzesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/admin/campus-resources': typeof AdminCampusResourcesRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/quizzes': typeof AdminQuizzesRouteWithChildren
  '/admin/user-management': typeof AdminUserManagementRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/quizzes/$quizId': typeof AdminQuizzesQuizIdRoute
  '/admin/quizzes/': typeof AdminQuizzesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access-denied'
    | '/admin'
    | '/login'
    | '/admin/analytics'
    | '/admin/articles'
    | '/admin/campus-resources'
    | '/admin/notifications'
    | '/admin/quizzes'
    | '/admin/user-management'
    | '/admin/'
    | '/admin/quizzes/$quizId'
    | '/admin/quizzes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access-denied'
    | '/login'
    | '/admin/analytics'
    | '/admin/articles'
    | '/admin/campus-resources'
    | '/admin/notifications'
    | '/admin/user-management'
    | '/admin'
    | '/admin/quizzes/$quizId'
    | '/admin/quizzes'
  id:
    | '__root__'
    | '/'
    | '/access-denied'
    | '/admin'
    | '/login'
    | '/admin/analytics'
    | '/admin/articles'
    | '/admin/campus-resources'
    | '/admin/notifications'
    | '/admin/quizzes'
    | '/admin/user-management'
    | '/admin/'
    | '/admin/quizzes/$quizId'
    | '/admin/quizzes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessDeniedRoute: typeof AccessDeniedRoute
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/user-management': {
      id: '/admin/user-management'
      path: '/user-management'
      fullPath: '/admin/user-management'
      preLoaderRoute: typeof AdminUserManagementRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quizzes': {
      id: '/admin/quizzes'
      path: '/quizzes'
      fullPath: '/admin/quizzes'
      preLoaderRoute: typeof AdminQuizzesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/notifications': {
      id: '/admin/notifications'
      path: '/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminNotificationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/campus-resources': {
      id: '/admin/campus-resources'
      path: '/campus-resources'
      fullPath: '/admin/campus-resources'
      preLoaderRoute: typeof AdminCampusResourcesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/articles': {
      id: '/admin/articles'
      path: '/articles'
      fullPath: '/admin/articles'
      preLoaderRoute: typeof AdminArticlesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quizzes/': {
      id: '/admin/quizzes/'
      path: '/'
      fullPath: '/admin/quizzes/'
      preLoaderRoute: typeof AdminQuizzesIndexRouteImport
      parentRoute: typeof AdminQuizzesRoute
    }
    '/admin/quizzes/$quizId': {
      id: '/admin/quizzes/$quizId'
      path: '/$quizId'
      fullPath: '/admin/quizzes/$quizId'
      preLoaderRoute: typeof AdminQuizzesQuizIdRouteImport
      parentRoute: typeof AdminQuizzesRoute
    }
  }
}

interface AdminQuizzesRouteChildren {
  AdminQuizzesQuizIdRoute: typeof AdminQuizzesQuizIdRoute
  AdminQuizzesIndexRoute: typeof AdminQuizzesIndexRoute
}

const AdminQuizzesRouteChildren: AdminQuizzesRouteChildren = {
  AdminQuizzesQuizIdRoute: AdminQuizzesQuizIdRoute,
  AdminQuizzesIndexRoute: AdminQuizzesIndexRoute,
}

const AdminQuizzesRouteWithChildren = AdminQuizzesRoute._addFileChildren(
  AdminQuizzesRouteChildren,
)

interface AdminRouteChildren {
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminArticlesRoute: typeof AdminArticlesRoute
  AdminCampusResourcesRoute: typeof AdminCampusResourcesRoute
  AdminNotificationsRoute: typeof AdminNotificationsRoute
  AdminQuizzesRoute: typeof AdminQuizzesRouteWithChildren
  AdminUserManagementRoute: typeof AdminUserManagementRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminArticlesRoute: AdminArticlesRoute,
  AdminCampusResourcesRoute: AdminCampusResourcesRoute,
  AdminNotificationsRoute: AdminNotificationsRoute,
  AdminQuizzesRoute: AdminQuizzesRouteWithChildren,
  AdminUserManagementRoute: AdminUserManagementRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessDeniedRoute: AccessDeniedRoute,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
